import React, {useState} from 'react';
import {Button, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {Drawer} from '../Drawer';
import {IconIllustration} from '../IconIllustration';
import { LatePaymentDrawerProps } from './types';

const {learnMore, agreementText} = translations['pt-br'].commons;
const {title, description} = translations['pt-br'].privateFlow.home.financialsDelayDrawer;

export const LatePaymentDrawer = ({dataTagId}: LatePaymentDrawerProps) => {
	const [openState, setOpenState] = useState(false);
	const handleOpen = () => {
		setOpenState(true);
	};

	const handleClose = () => {
		setOpenState(false);
	};

	return (
		<Stack alignItems={'flex-end'}>
			<Button size="small" variant="text" onClick={handleOpen} data-tag-id={dataTagId?.openDrawerButton}>
				{learnMore}
			</Button>
			<Drawer.Root
				open={openState}
				onClose={handleClose}
				onOpen={handleOpen}
				width={'396px'}
				customMaxHeight={'100%'}
				pullerPadding={'12px 0 0 0'}>
				<Drawer.Header closeBtnDataTagId={dataTagId?.closeDrawerButton} title="" onClose={handleClose} containerPadding={'0px 16px'} />
				<Drawer.Content $customPadding={'0 16px 16px'}>
					<Stack gap={2} alignItems={'center'}>
						<IconIllustration variant="warning" size="small" />
						<Typography variant="h6" lineHeight={'26px'}>
							{title}
						</Typography>
						<Stack gap={1}>
							<Typography variant="body1">{description.line1}</Typography>
							<Typography variant="body1">{description.line2}</Typography>
						</Stack>
					</Stack>
				</Drawer.Content>
				<Drawer.Footer
					hideFirstButton
					secondButtonTitle={agreementText}
					secondButtonOnClick={handleClose}
					secondButtonDataTagId={dataTagId?.understandButton}
				/>
			</Drawer.Root>
		</Stack>
	);
};
